export default {
  'Hello, {{name}}!': 'Hello, {{name}}!',
  'Sorry, we cannot find your business profile. Please complete the onboarding to log in.':
    'Sorry, we cannot find your business profile. Please complete the onboarding to log in.',
  Proceed: 'Proceed',
};
